import Pages from './pages';

export default Pages;
